import { constants } from '../../constants'

export const extractSectionFlags = data => {
    return constants.productDetailSections.reduce((acc, { key }) => {
        if (data[key] && data[key].hasOwnProperty('flag')) {
            return acc.concat({ key, flag: data[key].flag })
        } else {
            return acc
        }
    }, [])
}

export const setFiltersToDefaultValue = filters => {
    return filters.map(filter => {
        const cloneFilter = { ...filter }
        cloneFilter['display_value'] = cloneFilter.defaultDisplayValue
        cloneFilter['post_value'] = cloneFilter.defaultPostValue
        return cloneFilter
    })
}

export const mapClonedProduct = data => {
    /** removing parent id and modified areas from the product so that
     * we don't need to display the modified areas if the product is published to production */
    if (data.visibility === constants.productVisibilities.PROD) {
        delete data.parent_id
        delete data.modified_area
        return data
    }
    const { parent_id, modified_area = [] } = data

    /** if the cloned product is created but not yet modified then change the status to "NOT STARTED" */
    if (!!parent_id && !modified_area.length) {
        data.setup = constants.productSetupStatuses.NOT_STARTED
        return data
    } else if (
        !!parent_id &&
        modified_area.length &&
        data.setup !== constants.productSetupStatuses.INCOMPLETE
    ) {
        data.setup = 'saved'
    }

    /** Parsing the modified areas for the cloned product */
    let modifiedAreasObj = {}
    if (modified_area.length) {
        modified_area.forEach(area => {
            const arr = area.split('.')
            const section = arr[0]
            const field = arr.pop()
            /**
             * Creating the section level modified areas object
             */
            if (constants.productSectionTitles.hasOwnProperty(section)) {
                if (!modifiedAreasObj.hasOwnProperty(section)) {
                    modifiedAreasObj[section] = { [field]: 1 }
                } else {
                    modifiedAreasObj[section] = { ...modifiedAreasObj[section], [field]: 1 }
                }
            }
        })
        data['modified_area'] = modifiedAreasObj
    }

    return data
}
